__turbopack_context__.v({
  "block": "m7Jo6G_block",
  "blockDark": "m7Jo6G_blockDark",
  "blockLight": "m7Jo6G_blockLight",
  "headline": "m7Jo6G_headline",
  "inner": "m7Jo6G_inner",
  "root": "m7Jo6G_root",
  "stickySlot": "m7Jo6G_stickySlot",
  "title": "m7Jo6G_title",
});
